import { ApiProperty } from "@nestjs/swagger";


export class CompanyIdBiMsgIdRequest {
    @ApiProperty()
    companyId: number;
    @ApiProperty()
    biMsgIds: number[];
    @ApiProperty()
    moduleId: number;
    @ApiProperty()
    username?: string;

    /**
     * 
     * @param companyId 
     * @param biMsgIds 
     * @param moduleId 
     */
    constructor(companyId: number, biMsgIds: number[], moduleId: number, username: string) {
        this.companyId = companyId;
        this.biMsgIds = biMsgIds;
        this.moduleId = moduleId;
        this.username = username;
    }
}